import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { environment } from '../../../../environments/environment';
import {
  MediaPermissionState,
  UpdateMediaPermissionRequest,
  UserMediaPermissionSnapshot,
} from '../../models/consent/media-permission.model';
import { Observable } from 'rxjs';
import { BaseApiResponse } from '../../models/api/api.model';

@Injectable({ providedIn: 'root' })
export class MediaPermissionService {
  private readonly baseUrl =
    environment.apiLocations.identity + '/media-permissions';

  constructor(private readonly apiService: ApiService) {}

  getMyPermissions(): Observable<BaseApiResponse<MediaPermissionState>> {
    return this.apiService.get<MediaPermissionState>(`${this.baseUrl}/me`);
  }

  updateMyPermissions(
    payload: UpdateMediaPermissionRequest
  ): Observable<BaseApiResponse<MediaPermissionState>> {
    return this.apiService.put<MediaPermissionState>(
      `${this.baseUrl}/me`,
      payload
    );
  }

  getPermissionsByUserIds(
    userIds: string[]
  ): Observable<BaseApiResponse<UserMediaPermissionSnapshot[]>> {
    const ids = (userIds || []).filter(Boolean);
    const params = ids.length > 0 ? { userIds: ids.join(',') } : {};
    return this.apiService.get<UserMediaPermissionSnapshot[]>(
      `${this.baseUrl}`,
      params
    );
  }
}
